import { Link } from 'react-router-dom';
import { SurfaceBanner } from '../components/SurfaceBanner';
import { readSurfaceState } from '../lib/surface-state';

export function NotFoundPage() {
  return <section className="page narrow stack-lg"><SurfaceBanner state={readSurfaceState()} /><p className="eyebrow">404</p><h1>이 페이지는 아직 모름이에요.</h1><p className="lede">주소가 바뀌었거나 아직 만들지 않은 경로예요.</p><div className="inline"><Link className="button button-primary" to="/">홈으로 가기</Link><Link className="button" to="/start">좌석 고르기</Link></div></section>;
}
